<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->
		<div style="width:100%;background: #F1F1F1;overflow: hidden;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page='selected_page'></rosidebar>
				<div style="float: right;width:calc(100% - 269px);overflow: hidden;background: white;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 50px;text-align: left;padding-left: 20px;">
						我的订单 <span style="color:red"></span>
					</h6>
					<!-- <div style="width: 95%;margin:20px auto;border: 2px dotted #F0F0F0;padding:0 10px;">
						<div style="overflow: hidden;">
							<span style="float: left;line-height: 60px;">提交时间：</span>
							<el-row style="float: left;margin-top: 16px;">

								<el-checkbox v-model="check_date_all" label="全部时间">
								</el-checkbox>
								<el-checkbox v-model="check_date_3d" label="三天内"></el-checkbox>
								<el-checkbox v-model="check_date_7d" label="七天内"></el-checkbox>
								<el-checkbox v-model="check_date_3m" label="三个月内"></el-checkbox>
								<el-checkbox v-model="check_date_toyear" label="今年"></el-checkbox>
								<el-checkbox v-model="check_date_last_year" label="去年"></el-checkbox>
								<el-checkbox v-model="check_date_last_year_past" label="去年以前"></el-checkbox>

							</el-row>
						</div>
						<div style="overflow: hidden;">
							<span style="float: left;line-height: 60px;">委托类型：</span>
							<el-row style="float: left;margin-top: 16px;">
								<el-checkbox v-model="check_type_all" label="全部类型"></el-checkbox>
								<el-checkbox v-model="check_type_kjcx" label="科技查新"></el-checkbox>
								<el-checkbox v-model="check_type_kjcy" label="科技查引"></el-checkbox>
								<el-checkbox v-model="check_type_sci" label="查收"></el-checkbox>

							</el-row>
						</div>
						<div style="overflow: hidden;">
							<span style="float: left;line-height: 60px;">订单状态：</span>
							<el-row style="float: left;margin-top: 16px;">
								<el-checkbox v-model="check_state_all" label="全部状态"></el-checkbox>
								<el-checkbox v-model="check_state_draft" label="未提交"></el-checkbox>
								<el-checkbox v-model="check_state_approval" label="审核中"></el-checkbox>
								<el-checkbox v-model="check_state_search" label="查新中"></el-checkbox>
								<el-checkbox v-model="check_state_done" label="已完成"></el-checkbox>
								<el-checkbox v-model="check_state_close" label="已关闭"></el-checkbox>

							</el-row>
						</div>
					</div> -->
					<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
						style="margin-left: 20px;">
						<!-- 只保留已完成订单标签开始处 -->
						<el-menu-item index="0">全部订单</el-menu-item>
						</el-menu-item>
						<el-menu-item index="1">待修改</el-menu-item>
						</el-menu-item>
						<el-menu-item index="2">未提交</el-menu-item>
						</el-menu-item>
						<el-menu-item index="3">查新中</el-menu-item>
						</el-menu-item>
						<!-- 只保留已完成订单标签结束处 -->
						<el-menu-item index="4">已完成</el-menu-item>
						</el-menu-item>
					</el-menu>
					<div style="width: 95%;margin:20px auto;padding:0 10px;border: 2px dotted #F0F0F0;height: 50px;">

						<!-- <el-button size="small" style="float: left;margin-top: 8px;background-color: red;color:white;"
							@click="turn_to_kjcx()">创建查新订单</el-button>
						<el-button size="small" style="float: left;margin-top: 8px;background-color: red;color:white;"
							@click="turn_to_kjcy()">创建查引订单</el-button>
						<el-button size="small" style="float: left;margin-top: 8px;background-color: red;color:white;"
							@click="turn_to_sci()">创建SCI查收订单</el-button> -->
						<!-- <el-pagination style=";margin-top: 8px;float: right;" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-size="PageSize" background
							layout="total, prev, pager, next" :total="totalCount" v-if='state!="全部"'>
						</el-pagination> -->
						<el-pagination style=";margin-top: 8px;float: right;" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-size="totalCount" background
							layout="total, prev, pager, next" :total="totalCount">
						</el-pagination>
					</div>
					<!-- <div style="width: 95%;margin:20px auto;padding:0 10px;border: 2px dotted #F0F0F0;height: 50px;">
						
						<el-button size="small" style="float: left;margin-top: 8px;background-color: red;color:white;">生成付款通知</el-button>
						<el-pagination style="float: right;margin-top: 8px;" :page-sizes="[5, 10]" :page-size="5"
							layout="sizes, prev, pager, next" :total="user_notice_total.length">
						</el-pagination>
					</div> -->
					<!-- <el-button style="background-color: red;color:white">待修改订单</el-button> -->
					<!-- 只保留已完成订单标签开始处 -->
					<div style="background-color:#ff000096;color:white;width: 95%;margin:auto;padding: 1rem;" v-if="state=='全部'">待修改订单</div>
					<el-table :data="edit_order_datas" tooltip-effect="dark" stripe style="width: 95%;margin:auto;"
						v-if="state=='全部'" @selection-change="handleSelectionChange">

						<el-table-column prop="type" label="订单类型" sortable width="100">
						</el-table-column>
						<el-table-column prop="name" label="项目名称" width="260">
						</el-table-column>

						<el-table-column prop="total_fees" label="总金额" sortable width="100">
						</el-table-column>

						<el-table-column prop="write_date" label="最后更新时间" width="128" sortable v-if="state=='编辑中'">
						</el-table-column>
						<el-table-column prop="pay_date" label="支付时间" width="128" sortable
							v-if="state=='查新中'||state=='待修改'||state=='已完成'">
						</el-table-column>
						<el-table-column fixed='right' label="操作" width="250">
							<template slot-scope="scope">
								<el-button v-if="scope.row.state=='编辑中'" @click="turn_to_edit(scope.row)" type="success"
									size="small">编辑</el-button>
								<el-button v-if="scope.row.state=='待修改'" @click="turn_to_edit(scope.row)" type="success"
									size="small">修改</el-button>
								<el-button v-if="scope.row.state=='编辑中'" type="danger" @click="delete_order(scope.row)"
									size="small">删除</el-button>
								<el-button v-if="scope.row.state=='查新中'||scope.row.state=='完成'"
									@click="handleClick(scope.row)" type="success" size="small">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<h5 style="background-color:#07ccec;color:white;width: 95%;margin:auto;padding: 1rem;" v-if="state=='全部'">未提交订单</h5>
					<el-table :data="draft_order_datas" tooltip-effect="dark" stripe style="width: 95%;margin:auto;"
						v-if="state=='全部'" @selection-change="handleSelectionChange">

						<el-table-column prop="type" label="订单类型" sortable width="100">
						</el-table-column>
						<el-table-column prop="name" label="项目名称" width="260">
						</el-table-column>

						<el-table-column prop="total_fees" label="总金额" sortable width="100">
						</el-table-column>

						<el-table-column prop="write_date" label="最后更新时间" width="128" sortable v-if="state=='编辑中'">
						</el-table-column>
						<el-table-column prop="pay_date" label="支付时间" width="128" sortable
							v-if="state=='查新中'||state=='待修改'||state=='已完成'">
						</el-table-column>
						<el-table-column fixed='right' label="操作" width="250">
							<template slot-scope="scope">
								<el-button v-if="scope.row.state=='编辑中'" @click="turn_to_edit(scope.row)" type="success"
									size="small">编辑</el-button>
								<el-button v-if="scope.row.state=='待修改'" @click="turn_to_edit(scope.row)" type="success"
									size="small">修改</el-button>
								<el-button v-if="scope.row.state=='编辑中'" type="danger" @click="delete_order(scope.row)"
									size="small">删除</el-button>
								<el-button v-if="scope.row.state=='查新中'||scope.row.state=='完成'"
									@click="handleClick(scope.row)" type="success" size="small">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<h5 style="background-color:#fec624;color:white;width: 95%;margin:auto;padding: 1rem;" v-if="state=='全部'">查新中</h5>
					<el-table :data="checking_order_datas" tooltip-effect="dark" stripe style="width: 95%;margin:auto;"
						v-if="state=='全部'" @selection-change="handleSelectionChange">

						<el-table-column prop="type" label="订单类型" sortable width="100">
						</el-table-column>
						<el-table-column prop="name" label="项目名称" width="260">
						</el-table-column>

						<el-table-column prop="total_fees" label="总金额" sortable width="100">
						</el-table-column>

						<el-table-column prop="write_date" label="最后更新时间" width="128" sortable v-if="state=='编辑中'">
						</el-table-column>
						<el-table-column prop="pay_date" label="支付时间" width="128" sortable
							v-if="state=='查新中'||state=='待修改'||state=='已完成'">
						</el-table-column>
						<el-table-column fixed='right' label="操作" width="250">
							<template slot-scope="scope">
								<el-button v-if="scope.row.state=='编辑中'" @click="turn_to_edit(scope.row)" type="success"
									size="small">编辑</el-button>
								<el-button v-if="scope.row.state=='待修改'" @click="turn_to_edit(scope.row)" type="success"
									size="small">修改</el-button>
								<el-button v-if="scope.row.state=='编辑中'" type="danger" @click="delete_order(scope.row)"
									size="small">删除</el-button>
								<el-button v-if="scope.row.state=='查新中'||scope.row.state=='完成'"
									@click="handleClick(scope.row)" type="success" size="small">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- 只保留已完成订单标签结束处 -->
					<h5 style="background-color:#28a745;color:white;width: 95%;margin:auto;padding: 1rem;" v-if="state=='全部'">已完成订单</h5>
					<el-table :data="finish_order_datas" tooltip-effect="dark" stripe style="width: 95%;margin:auto;"
						v-if="state=='全部'" @selection-change="handleSelectionChange">

						<el-table-column prop="type" label="订单类型" sortable width="100">
						</el-table-column>
						<el-table-column prop="name" label="项目名称" width="260">
						</el-table-column>

						<el-table-column prop="total_fees" label="总金额" sortable width="100">
						</el-table-column>

						<el-table-column prop="write_date" label="最后更新时间" width="128" sortable v-if="state=='编辑中'">
						</el-table-column>
						<el-table-column prop="pay_date" label="支付时间" width="128" sortable
							v-if="state=='查新中'||state=='待修改'||state=='已完成'">
						</el-table-column>
						<el-table-column fixed='right' label="操作" width="250">
							<template slot-scope="scope">
								<el-button v-if="scope.row.state=='编辑中'" @click="turn_to_edit(scope.row)" type="success"
									size="small">编辑</el-button>
								<el-button v-if="scope.row.state=='待修改'" @click="turn_to_edit(scope.row)" type="success"
									size="small">修改</el-button>
								<el-button v-if="scope.row.state=='编辑中'" type="danger" @click="delete_order(scope.row)"
									size="small">删除</el-button>
								<el-button v-if="scope.row.state=='查新中'||scope.row.state=='完成'"
									@click="handleClick(scope.row)" type="success" size="small">查看</el-button>
							</template>
						</el-table-column>
					</el-table>


					<el-table :data="order_datas" tooltip-effect="dark" stripe style="width: 95%;margin:auto;"
						v-if='state!="全部"' @selection-change="handleSelectionChange">
						<!-- <el-table-column type="selection" width="55"> -->
						<!-- </el-table-column> -->
						<!-- <el-table-column prop="code" label="订单编号" sortable width="150">
						</el-table-column> -->
						<el-table-column prop="type" label="订单类型" sortable width="100">
						</el-table-column>
						<el-table-column prop="name" label="项目名称" width="260">
						</el-table-column>
						<!-- 	<el-table-column prop="unit_name" label="单位名称" sortable width="140">
						</el-table-column> -->

						<el-table-column prop="total_fees" label="总金额" sortable width="100">
						</el-table-column>

						<el-table-column prop="write_date" label="最后更新时间" width="128" sortable v-if="state=='编辑中'">
						</el-table-column>

						<el-table-column prop="pay_date" label="支付时间" width="128" sortable
							v-if="state=='查新中'||state=='待修改'||state=='已完成'">
						</el-table-column>
						<el-table-column fixed='right' label="操作" width="250">
							<template slot-scope="scope">
								<el-button v-if="scope.row.state=='编辑中'" @click="turn_to_edit(scope.row)" type="success"
									size="small">编辑</el-button>
								<el-button v-if="scope.row.state=='待修改'" @click="turn_to_edit(scope.row)" type="success"
									size="small">修改</el-button>
								<el-button v-if="scope.row.state=='编辑中'" type="danger" @click="delete_order(scope.row)"
									size="small">删除</el-button>
								<el-button v-if="scope.row.state=='查新中'||scope.row.state=='完成'"
									@click="handleClick(scope.row)" type="success" size="small">查看</el-button>
							</template>
						</el-table-column>
					</el-table>


				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'user_order',
		data() {
			return {
				activeIndex: '0',
				type: 'tech', //默认科技查新
				selected_page: '3-1',
				edit_order_datas:[],
				checking_order_datas:[],
				draft_order_datas:[],
				finish_order_datas:[],
				check_date_all: true,
				check_date_3d: false,
				check_date_7d: false,
				check_date_3m: false,
				check_date_toyear: false,
				check_date_last_year: false,
				check_date_last_year_past: false,
				check_type_all: true,
				check_type_kjcx: false,
				check_type_kjcy: false,
				check_type_sci: false,
				check_state_all: true,
				check_state_draft: false,
				check_state_approval: false,
				check_state_search: false,
				check_state_done: false,
				check_state_close: false,
				order_datas: [],
				now_select_order: {},
				state: '全部',
				currentPage: 1,
				// 总条数，根据接口获取数据长度(注意：这里不能为空)
				totalCount: 0,
				// 个数选择器（可修改）
				// 默认每页显示的条数（可修改）
				PageSize: 12,


			}
		},
		mounted() {
			var self = this
			var type = this.$route.query.type
			// debugger
			if (type != undefined) {
				this.state = '编辑中'
				this.activeIndex = '2'
			}

			this.get_order_info()
			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {

			handleCurrentChange(val) {
				console.log(val)
				console.log('handleCurrentChange')
				this.currentPage = val
				this.get_order_info()
			},




			handleClose(done) {
				var self = this
				this.$confirm('确认删除？')
					.then(_ => {
						console.log('slslslsl')
						var data = {
							'id': self.now_select_order.id
						}
						fetchPost('/ro/tec_search/order/delete/v1', data).then(response => {
							if(response.data.result=='session_expired'){
								window.location.href='/#/pages/login'
							}
							self.get_order_info()
						})
					})
					.catch(_ => {});
			},

			delete_order(row) {

				var self = this
				this.now_select_order = row
				self.handleClose()
			},
			handleSelect(key, keyPath) {
				console.log(key);
				if (key == 0) {
					this.state = '全部'
				}
				if (key == 1) {
					this.state = '待修改'
				}
				if (key == 2) {
					this.state = '编辑中'
				}
				if (key == 3) {
					this.state = '查新中'
				}
				if (key == 4) {
					this.state = '已完成'
				}
				this.get_order_info()

			},
			turn_to_kjcx() {
				this.$router.push('/user/kjcx')
			},
			turn_to_kjcy() {
				this.$router.push('/user/kjcy')
			},
			turn_to_sci() {
				this.$router.push('/user/SCI')
			},
			turn_to_edit(row) {
				if (row.type == '科技查新') {
					console.log(row)
					this.$router.push({
						path: '/user/kjcx',
						query: {
							id: row.id
						}
					})
				}
				if (row.type == '科技查引') {
					console.log(row)
					this.$router.push({
						path: '/user/kjcy',
						query: {
							id: row.id
						}
					})
				}
				if (row.type == 'SCI查收') {
					console.log(row)
					this.$router.push({
						path: '/user/SCI',
						query: {
							id: row.id
						}
					})
				}
			},
			handleClick(row) {

				// window.localStorage.setItem('now_click_order_info', JSON.stringify(row))
				this.$router.push('/user/order_infor?id=' + row.id)
			},
			get_order_info() {
				var self = this
				// debugger
				var data = {
					'id': window.localStorage.getItem('user_id'),
					'state': this.state,
					'page': this.currentPage,
					'page_size': this.PageSize,
				}
				fetchPost('/ro/tec_search/order/list/v1', data).then(function(response) {
					if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
					
					// debugger
					self.order_datas = response.data.list
					self.edit_order_datas = self.order_datas.filter(item=>item.state=='待修改')
					self.draft_order_datas = self.order_datas.filter(item=>item.state=='编辑中')
					self.checking_order_datas = self.order_datas.filter(item=>item.state=='查新中')
					self.finish_order_datas = self.order_datas.filter(item=>item.state=='完成')
					// debugger
					console.log(self.order_datas)
					self.totalCount = response.data.totalCount
				})
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			tabClick(row, column, cell, event) {
				switch (column.label) {
					case '顺序':
						this.tabClickIndex = row.index
						this.tabClickLabel = column.label
						break
					default:
						return
				}
				console.log('tabClick', this.tabClickIndex, row.adName, row.adSort)
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				// 把每一行的索引放进row
				row.index = rowIndex
			},

		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center !important;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center !important;
	}

	/* 	.el-checkbox.is-bordered{
		padding:6px !important;
		
		height: auto;
	}
	.el-checkbox{
		margin-right: 0px;
	}
	.el-checkbox__label{
		font-size: 12px !important;
	} */
</style>